/**
 * Centralized helpers for subscription status envelopes coming from the API.
 */
export const SUBSCRIPTION_STATUS = Object.freeze({
    VIEW_ONLY: 'VIEW_ONLY',
    PRIVILEGED_USER: 'PRIVILEGED_USER',
    ACTIVE: 'ACTIVE',
    ACTIVE_CANCELLED: 'ACTIVE_CANCELLED',
    TRIAL_WITH_CARD: 'TRIAL_WITH_CARD',
    TRIAL_WITHOUT_CARD: 'TRIAL_WITHOUT_CARD',
    TRIAL_CANCELLED: 'TRIAL_CANCELLED',
});

const DEFAULT_SUBSCRIPTION_DETAILS = Object.freeze({
    status: SUBSCRIPTION_STATUS.VIEW_ONLY,
    isInTrial: false,
    hasActivePlan: false,
    hasCard: false,
    hasCancelledSubscription: false,
    hasPrivilegedUserPermissions: false,
});

export function normalizeSubscriptionDetails(raw = null) {
    const statusValue =
        typeof raw?.status === 'string'
            ? raw.status.toUpperCase()
            : DEFAULT_SUBSCRIPTION_DETAILS.status;

    const normalizedStatus = Object.values(SUBSCRIPTION_STATUS).includes(
        statusValue
    )
        ? statusValue
        : DEFAULT_SUBSCRIPTION_DETAILS.status;

    return Object.freeze({
        ...DEFAULT_SUBSCRIPTION_DETAILS,
        ...raw,
        status: normalizedStatus,
    });
}

export function shouldShowPopup(userStore) {
    if (!userStore.user) {
        return false;
    }
    if (!userStore.isCompanyAdmin) {
        return false;
    }
    if (
        userStore.subscriptionStatus === SUBSCRIPTION_STATUS.VIEW_ONLY ||
        userStore.subscriptionStatus === SUBSCRIPTION_STATUS.TRIAL_WITHOUT_CARD ||
        userStore.subscriptionStatus === SUBSCRIPTION_STATUS.TRIAL_CANCELLED ||
        userStore.subscriptionStatus === SUBSCRIPTION_STATUS.ACTIVE_CANCELLED
    ) {
        return true;
    }

    return false;
}
